<div class="iackathon-deliverable-list-page__header">
    <div class="iackathon-deliverable-list-page__header-left">
        <a class="iackathon-deliverable-list-page__back-link"
           [routerLink]="getBackHref()">
            <mat-icon svgIcon="arrow_left_alt_rounded"></mat-icon>
            <span>{{ 'iackathon.back' | translate }}</span>
        </a>
        <h1 class="iackathon-deliverable-list-page__title">
            {{ 'iackathon.deliverable_library' | translate }}
        </h1>
    </div>
    @if (isTrainerExperience) {
        <div class="iackathon-deliverable-list-page__header-right">
            <mat-form-field class="iackathon-deliverable-list-page__moderation-field">
                <mat-label>{{ 'iackathon.moderation_filter' | translate }}</mat-label>
                <mat-select [value]="activeModerationFilter()"
                            (selectionChange)="onModerationFilterChange($event.value)"
                            panelClass="iackathon-deliverable-list-page__select-panel">
                    @for (filter of moderationFilters; track filter) {
                        <mat-option [value]="filter">
                            {{ getModerationFilterOptionKey(filter) | translate }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    }
</div>

@if (isLoading()) {
    <mat-spinner></mat-spinner>
} @else {
    <div class="iackathon-deliverable-list-page__group-list-wrapper">
        @if (groupSaves().length === 0) {
            <p class="iackathon-deliverable-list-page__empty-message">
                {{ 'iackathon.no_deliverables' | translate }}
            </p>
        } @else {
            <ul class="iackathon-deliverable-list-page__group-list">
                @for (group of groupSaves(); track group.id) {
                    @let state = group.attributes.content.state;
                    @let members = getSaveMembers(group);
                    <li class="iackathon-deliverable-list-page__group-item">
                        <button class="iackathon-deliverable-list-page__group-button"
                                [class.iackathon-deliverable-list-page__group-button--selected]="selectedSave()?.id === group.id"
                                [attr.aria-controls]="'iackathon-deliverable-list-page-card'"
                                [attr.aria-pressed]="selectedSave()?.id === group.id"
                                (click)="onSelectSaveChange(group.id)">
                            <div class="iackathon-deliverable-list-page__group-icon-box">
                                <mat-icon class="iackathon-deliverable-list-page__group-icon"
                                        [svgIcon]="getDeliverableFormatIcon(state.deliverable.format)">
                                </mat-icon>
                            </div>
                            <div class="iackathon-deliverable-list-page__group-info">
                                <span class="iackathon-deliverable-list-page__group-name">
                                    {{ state.group_name || ('iackathon.outdated_save' | translate) }}
                                </span>
                                <span class="iackathon-deliverable-list-page__group-members">
                                    @if (members.length) {
                                        @for (member of members; track member.id) {
                                            <span>{{ member.name }}</span>
                                            <span>{{ $last ? null : ', ' }}</span>
                                        }
                                    } @else {
                                        <span>{{ group.attributes.owner.username }}</span>
                                    }
                                </span>
                            </div>
                            <div class="iackathon-deliverable-list-page__group-idea">
                                {{ getSaveIdeaLabel(group) }}
                            </div>
                            @if (isTrainerExperience) {
                                <div class="iackathon-deliverable-list-page__group-deliverable-status">
                                    {{ getModerationStatusLabelKey(getModerationStatus(group)) | translate }}
                                </div>
                            }
                        </button>
                    </li>
                }
            </ul>
        }
    </div>

    <section class="iackathon-deliverable-list-page__card"
             id="iackathon-deliverable-list-page-card">
        @if (selectedSave(); as selectedSave) {
            @let state = selectedSave.attributes.content.state;
            @let deliverable = state.deliverable;
            @let topSpecialMark = getTopSpecialMark(selectedSave);
            <div class="iackathon-deliverable-list-page__card-header"
                 animate.enter="iackathon-deliverable-list-page__card-header--fade-in"
                 animate.leave="iackathon-deliverable-list-page__card-header--fade-out">
                <div class="iackathon-deliverable-list-page__preview-wrapper">
                    @switch (typeOfDeliverable(deliverable)) {
                        @case ('pdf') {
                            <div class="iackathon-deliverable-list-page__pdf-icon-box">
                                <mat-icon class="iackathon-deliverable-list-page__pdf-icon"
                                          svgIcon="pdf_file_custom">
                                </mat-icon>
                            </div>
                            <a class="iackathon-deliverable-list-page__open-pdf-link"
                                [href]="deliverable.url"
                                target="_blank"
                                download>
                                <span>{{ 'iackathon.open_pdf' | translate }}</span>
                                <mat-icon svgIcon="open_in_new"></mat-icon>
                            </a>
                        }
                        @case ('image') {
                            <img class="iackathon-deliverable-list-page__image-preview"
                                 [src]="deliverable.url"
                                 [alt]="'iackathon.image_deliverable' | translate">
                            <button class="iackathon-deliverable-list-page__expand-image-button"
                                    [matTooltip]="'iackathon.enlarge_image' | translate"
                                    [attr.aria-label]="'iackathon.enlarge_image' | translate"
                                    (click)="onZoomButtonClick()">
                                <mat-icon svgIcon="iackathon-deliverable-list-page__expand">
                            </mat-icon>
                            </button>
                        }
                        @case ('audio') {
                            <div class="iackathon-deliverable-list-page__audio-icon-box">
                                <mat-icon class="iackathon-deliverable-list-page__audio-icon"
                                          svgIcon="graphic_eq_rounded">
                                </mat-icon>
                                <mat-icon class="iackathon-deliverable-list-page__audio-icon"
                                          svgIcon="graphic_eq_rounded">
                                </mat-icon>
                            </div>
                            <app-iackathon-media-player [mediaType]="'audio'"
                                                         [src]="deliverable.url"
                                                         [ariaLabel]="getSaveIdeaLabel(selectedSave)">
                            </app-iackathon-media-player>
                        }
                        @case ('video') {
                            <app-iackathon-media-player [mediaType]="'video'"
                                                         [src]="deliverable.url"
                                                         [ariaLabel]="getSaveIdeaLabel(selectedSave)">
                            </app-iackathon-media-player>
                        }
                        @default {
                            <div class="iackathon-deliverable-list-page__default-icon-box">
                                <mat-icon class="iackathon-deliverable-list-page__default-icon"
                                          svgIcon="language">
                                </mat-icon>
                            </div>
                            <a class="iackathon-deliverable-list-page__open-default-link"
                                [href]="deliverable.url"
                                target="_blank"
                                download>
                                <span>{{ 'iackathon.open_deliverable' | translate }}</span>
                                <mat-icon svgIcon="open_in_new"></mat-icon>
                            </a>
                        }
                    }
                </div>
                <h2 class="iackathon-deliverable-list-page__card-title">
                    {{ getSaveIdeaLabel(selectedSave) }}
                </h2>
            </div>
            <div class="iackathon-deliverable-list-page__card-special-mark"
                 [class.iackathon-deliverable-list-page__card-special-mark--is-empty]="!topSpecialMark"
                 animate.enter="iackathon-deliverable-list-page__card-special-mark--fade-in"
                 animate.leave="iackathon-deliverable-list-page__card-special-mark--fade-out"
                 [attr.data-special-mark]="topSpecialMark?.value">
                @if (topSpecialMark) {
                    <img [src]="'assets/'+ brand +'/images/pseudo-icons/' + topSpecialMark.pseudoIcon + '.png'"
                         aria-hidden="true">
                    <span>{{ topSpecialMark.label }}</span>
                }
            </div>
            <div class="iackathon-deliverable-list-page__card-actions"
                 animate.enter="iackathon-deliverable-list-page__card-actions--fade-in"
                 animate.leave="iackathon-deliverable-list-page__card-actions--fade-out">
                @if (isTrainerExperience) {
                    <button class="iackathon-deliverable-list-page__approve-button"
                            [disabled]="isModerationSaving() || getModerationStatus(selectedSave) === 'approved'"
                            (click)="onApproveDeliverableButtonClick(selectedSave)">
                        {{ 'iackathon.approve_deliverable' | translate }}
                    </button>
                    <button class="iackathon-deliverable-list-page__reject-button"
                            [disabled]="isModerationSaving() || getModerationStatus(selectedSave) === 'rejected'"
                            (click)="onRejectDeliverableButtonClick(selectedSave)">
                        {{ 'iackathon.reject_deliverable' | translate }}
                    </button>
                    <button class="iackathon-deliverable-list-page__mark-pending-button"
                            [disabled]="isModerationSaving() || getModerationStatus(selectedSave) === 'pending'"
                            (click)="onResetDeliverableModerationButtonClick(selectedSave)">
                        {{ 'iackathon.mark_deliverable_pending' | translate }}
                    </button>
                }
                <!-- TODO: history page -->
                <!-- <a class="iackathon-deliverable-list-page__history-link"
                    [routerLink]="['/', 'iackathon-groups', selectedSave().id]">
                    {{ 'iackathon.view_group_history' | translate }}
                </a> -->
                <a class="iackathon-deliverable-list-page__download-link"
                   [href]="deliverable.url" target="_blank"
                   download>
                    {{ 'iackathon.download_deliverable' | translate }}
                </a>
                <!-- TODO: review dialog -->
                <!-- <button class="iackathon-deliverable-list-page__review-button"
                        (click)="onLearnersSelfReviewsButtonClick()">
                    {{ 'iackathon.learners_self_reviews' | translate }}
                </button> -->
            </div>
        }
    </section>
}
